<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">МЕДИЦИНСКИЕ УСЛУГИ И ПРОЦЕДУРЫ (АМБУЛАТОРНО)</h3>
            <div class="img-wrap">
                <img alt="" class="" src="/resource/img/">
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Для новых пациентов (посещающих Центр впервые)</h3>
            <h4 class="depth bullet02">Обслуживание в порядке очереди, без назначения приема</h4>
            <p class="depth">
                Заполните заявку на третьем этаже В1. Возьмите талон с номером очереди и предъявите заявку на медицинское обслуживание, свой страховой полис и ИД-карту в окне регистратуры, где отобразится ваш номер. Вам выдадут направление на амбулаторное обслуживание и направление на медицинское обслуживание. Предъявите направление на амбулаторное обслуживание в амбулаторном отделении.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Для пациентов, ранее посещавших Центр (для последующего наблюдения)</h3>

            <h4 class="depth bullet02">Если вы уже забронировали прием у врача</h4>
            <p class="depth">
                Рекомендуем прибыть по меньшей мере за 10 минут до запланированного приема и прийти непосредственно в отделение. <br>
                Предъявите направление на прием в посещаемом вами отделении.
            </p>

            <h4 class="depth bullet02">Если запись на прием производилась по телефону или онлайн (стационарный телефон, Интернет или мобильный телефон)</h4>
            <p class="depth">
                Рекомендуем прибыть по меньшей мере за 10 минут до запланированного приема и прийти непосредственно в отделение. <br>
                Покажите текстовое сообщение о назначенном приеме в окне регистратуры отделения
            </p>

            <h4 class="depth bullet02">Обслуживание в порядке очереди, без назначения приема</h4>
            <p class="depth">
                Возьмите талон с номером очереди и предъявите заявку на медицинское обслуживание и свой страховой полис в окне регистратуры, где отобразится ваш номер. Вам выдадут направление на амбулаторный прием. Предъявите направление на амбулаторный прием в отделении.
            </p>
            <p class="depth font-sub">※ Обслуживание без назначенного приема может быть завершено раньше в зависимости от обстановки в отделении.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>